import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling} from "../../helper";
// import { base_api_url , errorHandling } from "../../helper";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    user: {}
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    loginSuccess: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("token", `Bearer ${action.payload.token}`);
    },
    resetPasswordSuccess: (state) => {
      toast.success("Password reset successfully");
    }
  }
});

export const { loginSuccess, loading, resetPasswordSuccess } = authSlice.actions;

export const login = (loginData, navigate) =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin/admin_login`;
      console.log("before login submit");
      console.log(url);
     

      const { data } = await axios.post(url, loginData);
      dispatch(loginSuccess(data));
      toast.success("Login Success");
      dispatch(loading(false));
      navigate("/");
    } catch (error) {
      toast.error(error.response);
      dispatch(loading(false));
      errorHandling(error);
    }
  };

export const resetPassword = (passwordData, navigate) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const token = localStorage.getItem("token");
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/reset-password`;
    
    await axios.post(url, passwordData, {
      headers: {
        Authorization: token
      }
    });

    dispatch(resetPasswordSuccess());
    dispatch(loading(false));
    navigate("/dashboard");
  } catch (error) {
    toast.error(error.response?.data?.error || "Failed to reset password");
    dispatch(loading(false));
    errorHandling(error);
  }
};

export default authSlice.reducer;